import React from 'react';
import DevicesState from './devicesState/DevicesState';
import DevicesControlPanel from './components/DevicesControlPanel/DevicesControlPanel';
import Devices from './components/Devices/Devices';
import { ModalWindows } from './components/ModalWindows';
import DeviceFullInfoPage from 'modules/Devices/DeviceFullInfo';
import style from './index.module.scss';

const DevicesPage: React.FC = () => {
	return (
		<DevicesState>
			<div className={style.container} data-test="DevicesPage">
				<DevicesControlPanel />
				<Devices />
				<ModalWindows />
				<DeviceFullInfoPage />
			</div>
		</DevicesState>
	);
};

export default DevicesPage;
